var map = {
	"./music-instructions.json": 3079,
	"./music-library-intro2024.json": 3080,
	"./music-library-launch2024.json": 3081,
	"./music-progression.json": 3082,
	"./startSourcesAdvanced.json": 3083,
	"./startSourcesSimple.json": 3084,
	"./startSourcesSimple2.json": 3085,
	"./startSourcesTracks.json": 3086
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2853;